import { get, post } from '@integec/fetch-task'
// import moment from 'moment'
import qs from 'query-string'
// // import { toQueryStr } from './utils'
// import { DATE_FORMAT_API, DATE_TIME_FORMAT_API } from '../enum'

export const getViews = targetInfo => () =>
  get(targetInfo, `report-dashboard/views`)

export const getDispatchRun = targetInfo => (year, month) =>
  get(
    targetInfo,
    `report-dashboard/dispatch-run?${qs.stringify({
      year,
      month,
    })}`
  )

export const retrieveData = targetInfo => criteria =>
  post(targetInfo, `report-dashboard/retrieve`)(criteria)

export const saveProfile = targetInfo => profile =>
  post(targetInfo, `report-dashboard/save-profile`)(profile)

export const deleteProfile = targetInfo => profile =>
  post(targetInfo, `report-dashboard/delete-profile`)(profile)
